import * as React from 'react';
import { observer } from 'mobx-react';

import { PageConfirmBankAccountViewModel } from './page-confirm-bank-account-view-model';
import { PayerOnboardingUserAction } from '../../payer-onboarding-user-actions';
import { SubmitButton } from '../../../WebGiving/components/submit-button/submit-button';
import { Form } from '../../../WebGiving/primitives/form';
import { LeftChevronLink } from '../../../WebGiving/primitives/link/link';
import { ErrorMessage } from '../../components/error-message/error-message';
import { ResetPageReason } from '../../payer-onboarding-generated';
import { AccountNumberInput } from '../../../WebGiving/components/account-number-input';
import { FadeTransition } from '../../../WebGiving/components/fade-transition';
import { PanelContentTransition } from '../../../WebGiving/components/panel-content-transition';
import { getPageClasses} from '../helpers/get-page-classes';
import { PanelHeading } from '../../../WebGiving/components/panel-heading';
import { PanelFooter } from '../../../WebGiving/components/panel-footer';

import { pageFooter } from '../../../WebGiving/main/webgiving-main.less';

export { PageConfirmBankAccountViewModel };

@observer
export class PageConfirmBankAccount extends React.Component<{
	vm: PageConfirmBankAccountViewModel,
	raiseAction: (action: PayerOnboardingUserAction) => void,
	transitionState: string,
}> {
	panelBodyNode: HTMLDivElement;

	render() {
		const { vm, transitionState } = this.props;
		const { accountNumberConfirm, error, bankName, isLoading, pageShouldBeVisible, isBlocked } = vm;
		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Confirm Bank Account page` : null}>
				<PanelHeading vm={vm}>
					<FadeTransition in={elementsShouldEnter}>
						<div>
							<h1 className="panel-title">PAYMENT METHOD</h1>
							<p className="panel-subtitle">Please confirm your account number for <strong>{bankName}</strong>.</p>
							<LeftChevronLink acceptanceTestTargetId="change-account-number-link" onClick={this.handleChangeAccountDetails} branded={false}>Change bank account details</LeftChevronLink>
						</div>
					</FadeTransition>
				</PanelHeading>
				<Form onSubmit={this.handleSubmit}>
					<div className="panel-body panel-body-form" ref={this.savePanelBodyNode}>
						<PanelContentTransition in={elementsShouldEnter} setContentHeight={this.setContentHeight} className="panel-body-content">
							<div>
								<ErrorMessage error={error} onResetPage={this.handleResetPage}/>
								<div className="row">
									<div className="col-sm-8 col-centered">
										<AccountNumberInput
											value={accountNumberConfirm}
											formControlId="ach-account-number-confirm"
											label="Confirm your account number"
											focusOnMount
											acceptanceTestTargetId="Confirm ACH Account Number"
										/>
									</div>
								</div>
							</div>
						</PanelContentTransition>
					</div>
					<PanelFooter className={pageFooter}>
						<SubmitButton acceptanceTestTargetId="Next" isLoading={isLoading} isBlocked={isBlocked}>Next</SubmitButton>
					</PanelFooter>
				</Form>
			</div>
		);
	}

	setContentHeight = (offsetHeight: number) => {
		if (this.panelBodyNode) {
			this.panelBodyNode.style.minHeight = `${offsetHeight}px`;
		}
	}

	private savePanelBodyNode = (panelBodyNode: HTMLDivElement) => this.panelBodyNode = panelBodyNode;

	private handleChangeAccountDetails = (event: React.MouseEvent<HTMLAnchorElement>) => {
		this.props.raiseAction(new PayerOnboardingUserAction.ChangeBankDetails());
	}

	private handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		this.props.raiseAction(new PayerOnboardingUserAction.SubmitCurrentPage());
	}

	private handleResetPage = (reason?: ResetPageReason) => {
		this.props.raiseAction(new PayerOnboardingUserAction.ResetPageBecauseOfError(reason));
	}
}
